var _defs, _rect, _rect2, _path, _path2, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInspirationQuoteBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 378,
    height: 220,
    viewBox: "0 0 378 220",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28577",
    "data-name": "Rectangle 28577",
    width: 378,
    height: 220,
    rx: 15,
    transform: "translate(902 933)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_30",
    "data-name": "Mask Group 30",
    transform: "translate(-902 -933)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artwork_31",
    "data-name": "Artwork 31",
    transform: "translate(1091 1043)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_47917",
    "data-name": "Group 47917",
    transform: "translate(-189 -110)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20888",
    "data-name": "Rectangle 20888",
    width: 378,
    height: 220,
    transform: "translate(0 0)",
    fill: "#0e556f"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20888-2",
    "data-name": "Rectangle 20888",
    width: 378,
    height: 220,
    transform: "translate(0 0)",
    fill: "#0e556f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_47903",
    "data-name": "Group 47903",
    transform: "translate(5.013)",
    opacity: 0.1,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_140270",
    "data-name": "Path 140270",
    d: "M378,90.274V0H308.979L204.238,220h112Z",
    transform: "translate(-5.013 0)",
    fill: "#0e556f"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_140271",
    "data-name": "Path 140271",
    d: "M5.013,220H167.238L271.979,0H109.754Z",
    transform: "translate(-5.013 0)",
    fill: "#0e556f"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_47904",
    "data-name": "Group 47904",
    transform: "translate(352.582 180.16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_140272",
    "data-name": "Path 140272",
    d: "M356.446,188.16c5.148,0,5.156-8,0-8s-5.156,8,0,8Z",
    transform: "translate(-352.582 -180.16)",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_47905",
    "data-name": "Group 47905",
    transform: "translate(321.933 161.286)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_140273",
    "data-name": "Path 140273",
    d: "M323.382,164.286a1.5,1.5,0,0,0,0-3,1.5,1.5,0,0,0,0,3Z",
    transform: "translate(-321.933 -161.286)",
    fill: "#fff"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_47906",
    "data-name": "Group 47906",
    transform: "translate(355.48 34.464)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_140274",
    "data-name": "Path 140274",
    d: "M356.446,36.464a1,1,0,0,0,0-2,1,1,0,0,0,0,2Z",
    transform: "translate(-355.48 -34.464)",
    fill: "#fff"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_47907",
    "data-name": "Group 47907",
    transform: "translate(231.484 54.49)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_140275",
    "data-name": "Path 140275",
    d: "M232.933,57.49a1.5,1.5,0,0,0,0-3,1.5,1.5,0,0,0,0,3Z",
    transform: "translate(-231.484 -54.49)",
    fill: "#fff"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_47908",
    "data-name": "Group 47908",
    transform: "translate(69.656 39.778)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_140276",
    "data-name": "Path 140276",
    d: "M71.105,42.778a1.5,1.5,0,0,0,0-3,1.5,1.5,0,0,0,0,3Z",
    transform: "translate(-69.656 -39.778)",
    fill: "#fff"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_47909",
    "data-name": "Group 47909",
    transform: "translate(171.003 83.096)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_140277",
    "data-name": "Path 140277",
    d: "M172.452,86.1a1.5,1.5,0,0,0,0-3,1.5,1.5,0,0,0,0,3Z",
    transform: "translate(-171.003 -83.096)",
    fill: "#fff"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_47910",
    "data-name": "Group 47910",
    transform: "translate(116.726 17.64)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_140278",
    "data-name": "Path 140278",
    d: "M117.692,19.64a1,1,0,0,0,0-2,1,1,0,0,0,0,2Z",
    transform: "translate(-116.726 -17.64)",
    fill: "#fff"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_47911",
    "data-name": "Group 47911",
    transform: "translate(250.101 193.933)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_140279",
    "data-name": "Path 140279",
    d: "M251.067,195.933a1,1,0,0,0,0-2,1,1,0,0,0,0,2Z",
    transform: "translate(-250.101 -193.933)",
    fill: "#fff"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_47912",
    "data-name": "Group 47912",
    transform: "translate(221.064 139.173)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_140280",
    "data-name": "Path 140280",
    d: "M222.03,141.173a1,1,0,0,0,0-2,1,1,0,0,0,0,2Z",
    transform: "translate(-221.064 -139.173)",
    fill: "#fff"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_47913",
    "data-name": "Group 47913",
    transform: "translate(294.96 90.952)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_140281",
    "data-name": "Path 140281",
    d: "M295.926,92.952a1,1,0,0,0,0-2,1,1,0,0,0,0,2Z",
    transform: "translate(-294.96 -90.952)",
    fill: "#fff"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_47914",
    "data-name": "Group 47914",
    transform: "translate(10.475 98.032)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_140282",
    "data-name": "Path 140282",
    d: "M11.441,100.032a1,1,0,0,0,0-2,1,1,0,0,0,0,2Z",
    transform: "translate(-10.475 -98.032)",
    fill: "#fff"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Group_47915",
    "data-name": "Group 47915",
    transform: "translate(132.255 153.885)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_140283",
    "data-name": "Path 140283",
    d: "M133.221,155.885a1,1,0,0,0,0-2,1,1,0,0,0,0,2Z",
    transform: "translate(-132.255 -153.885)",
    fill: "#fff"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Group_47916",
    "data-name": "Group 47916",
    transform: "translate(24.796 137.923)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_140284",
    "data-name": "Path 140284",
    d: "M26.97,142.423c2.9,0,2.9-4.5,0-4.5s-2.9,4.5,0,4.5Z",
    transform: "translate(-24.797 -137.923)",
    fill: "#fff"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInspirationQuoteBg);
export default __webpack_public_path__ + "static/media/Inspiration_quote_bg.1d798a109446eb4ff971d10ed121e5c7.svg";
export { ForwardRef as ReactComponent };